const whiteList = [
  ".edu",
  ".edu.",
  ".ac.",
  "s.unibuc.ro",
  "bioc.uzh.ch",
  "student.usm.my",
  "studenti.unitn.it",
  "kuleuven.be",
  "etu.univ-lorraine.fr",
  "etu.unige.ch",
  "ufv.br",
  "dsf.unica.it",
  "quimica.unam.mx",
  "epfl.ch",
  "uem.br",
  "ufpe.nr",
  "ac.upatras.gr",
  "ciencias.unam.mx",
  "edu.itmo.ru",
  "esib.butantan.gov.br",
  "fau.de",
  "furg.br",
  "helsinki.fi",
  "hsleiden.nl",
  "mail.dcu.ie",
  "smail.bcw.h-brs.de",
  "studenti.unina.it",
  "tecnico.ulisboa.pt",
  "ualberta.ca",
  "ufmg.br",
  "uwaterloo.ca",
  "studenti.unisa.it",
  "atu.ie",
  "etu.u-paris.fr",
  "etu.unistra.fr",
  "farmaci.uu.se",
  "fizyka.umk.pl",
  "grad.ufsc.br",
  "knu.ua",
  "sfedu.ru",
  "tpu.ru",
  "unifesp.br",
  "unipd.it",
  "unipv.it",
  "univ-lorraine.fr",
  "usp.br",
  "uvm.cl",
  "yuhs.ac", 
  "mkuniversity.org",
  "studenti.unimi.it",
  "kkumail.com",
  "student.crsd.org",
  "univ-lille.fr",
  "u-paris.fr",
  "uzh.ch",
  "campus.tu-berlin.de",
  "ucm.cl",
  "chemistry.msu.ru",
  "kemi.dtu.dk",
  "tum.de",
  "biotec.rwth-aachen.de",
  "univ-lyon1.fr",
  "univ-nantes.fr",
  "ulaval.ca",
  "usms.ma",
  "um.si",
  "univ-paris-diderot.fr",
  "uniupo.it",
  "irapuato.tecnm.mx",
  "instec.cu",
  "irapuato.tecnm.mx",
  "fkit.unizg.hr",
  "ku.th",
  "udec.cl",
  "bsu.by",
  "students.uni-mainz.de",
  "stud.uni-saarland.de",
  "uliege.be",
  "ufpr.br",
  "student.dtu.dk",
  "unige.ch",
  "g.nsu.ru",
  "icf.unam.mx",
  "fu-berlin.de",
  "uniroma1.it",
  "kau.ac.kr",
  "unn.ru",
  "aluno.unb.br",
  "ugr.es",
  "unife.it",
  "medizin.uni-leipzig.de",
  "ntnu.no",
  "icm.uu.se",
  "nipgr.ac.in",
  "usach.cl",
  "oci.uni-hannover.de",
  "ciad.mx",
  "kau.kr",
  "cua.uam.mx",
  "ueb.cas.cz",
  "biol.uoa.gr",
  "sickkids.ca",
  "vitstudent.ac.in",
  "studenti.unipr.it",
  "pharm.auth.gr",
  "connect.ust.hk",
  "mail.mcgill.ca",
  "univ-tlse3.fr",
  "unive.it",
  "unipr.it",
  "agroparistech.fr",
  "xanum.uam.mx",
  "students.uniroma2.eu",
  "imm.ac.cn",
  "stud.uni-frankfurt.de",
  "shu.edu.cn",
  "mail.utoronto.ca",
  "oulu.fi",
  "hhu.de",
  "spcpu.ru",
  "usm.my",
  "unimi.it",
  "uji.es",
  "ibt.unam.mx",
  "usherbrooke.ca",
  "ens.psl.eu",
  "niperkolkata.edu.in",
  "universityofgalway.ie",
  "niuitmo.ru",
  "uv.cl",
  "etu.u-pec.fr",
  "liu.se",
  "eheb.ma",
  "stowers.org",
  "univ-djelfa.dz",
  "kisti.re.kr",
  "students.uu.nl",
  "ugent.be",
  "biof.ufrj.br",
  "umanitoba.ca",
  "alumnos.udg.mx",
  "email.umfiasi.ro",
  "univ-djelfa.dz",
  "kau.se",
  "chem.au.dk",
  "sgu.ru",
  "unibas.ch",
  "etu.u-bourgogne.fr",
  "edu.unige.it",
  "d.umfiasi.ro",
  "universite-paris-saclay.fr",
  "stud.uni-heidelberg.de",
  "utoronto.ca",
  "ucalgary.ca",
  "uni-goettingen.de",
  "cuchd.in",
  "universitadipavia.it",
  "ufes.br",
  "banasthali.in",
  "saveetha.com",
  "mun.ca",
  "univ-chlef.dz",
  "cinvestav.mx",
  "univ-reims.fr",
  "alu.ufc.br",
  "stu.dzu.edu.cn",
  "univ-tlemcen.dz",
  "discente.ufg.br",
  "ox.ac.uk",
  "stu.xmu.edu.cn",
  "chem.pmf.hr",
  "univaq.it",
  "science.unideb.hu",
  "campus.fct.unl.pt",
  "ufpe.br",
  "ufrj.br",
  "gitam.in",
  "qsar.chem.msu.ru",
  "ext.uv.es",
  "kunainital.ac.in",
  "iq.ufrj.br",
  "kunainital.ac.in",
  "unibe.ch",
  "izt.uam.mx",
  "uni-tuebingen.de",
  "ugto.mx",
  "rub.de",
  "student.uni-siegen.de",
  "studentmail.ul.ie",
  "tu-dresden.de",
  "dtu.dk",
  "tuni.fi",
  "sgu.ru",
  "utem.cl",
  "ipn.mx",
  "engenharia.ufjf.br",
  "imc.macro.ru",
  "uni-due.de",
  "ucd.ie",
  "usask.ca",
  "estudante.ufscar.br",
  "univ-st-etienne.fr",
  "um6ss.ma",
  "icb.ufpa.br",
  "ehu.uah.es",
  "tu-braunschweig.de",
  "etu.umontpellier.fr",
  "ipn.mx",
  "alumni.uniroma2.eu",
  "uni-greifswald.de",
  "matfyz.cuni.cz",
  "s.upc.edu.cn",
  "alumno.buap.mx",
  "ucdb.br",
  "uni-potsdam.de",
  "student.amity.edu",
  "unisa.it",
  "urfu.me",
  "kgut.ac.ir",
  "earlycharm.com",
  "chalmers.se",
  "uwo.ca",
  "uni-siegen.de",
  "ug.uchile.cl",
  "estudante.ufla.br",
  "uni-bayreuth.de",
  "sund.ku.dk",
  "sgtuniversity.org",
  "ufrgs.br",
  "etu.toulouse-inp.fr",
  "constructor.university",
  "ug.uchile.cl",
  "shivajiscamt.org",
  "vscht.cz",
  "estudante.ufla.br",
  "silcsbio.com",
  "comunidad.unam.mx",
  "koyauniversity.org",
  "pharm.uoa.gr",
  "alumnos.viu.es",
  "campus.lmu.de",
  "kluniversity.in",
  "mail.ntua.gr",
  "umfcluj.ro",
  "accademialucchese.it",
  "dokt.p.lodz.pl",
  "unimib.it",
  "student.uni.opole.pl",
  "uniroma2.it",
  "upol.cz",
  "uco.es",
  "kodomo.fbb.msu.ru",
  "alumnos.utalca.cl",
  "uct.cl",
  "gadvasu.in",
  "student.uni-augsburg.de",
  "pharm.uoa.gr",
  "rwth-aachen.de",
  "accademialucchese.it",
  "ceti.mx",
  "ufs.br",
  "chem.tu-berlin.de",
  "alumni.ku.dk",
  "ens-lyon.fr",
  "bio.unibuc.ro",
  "student.kau.in",
  "tcd.ie",
  "alumni.ku.dk",
  "ru.nl",
  "alumnos.utalca.cl",
  "stu.scau.edu.cn",
  "muni.cz",
  "edu.mirea.ru",
  "ubbcluj.ro",
  "tu-dortmund.de",
  "northeastern.edu",
  "ipu.ac.in",
  "unisucrevirtual.edu.co",
  "unica.it",
  "ubi.pt",
  "syphu.edu.cn",
  "estudiantes.uci.cu",
  "stu.scau.edu.cn",
  "students.uni-freiburg.de",
  "uni-miskolc.hu",
  "mail.ioffe.ru",
  "uantwerpen.be",
  "lcc.chem.msu.ru",
  "ki.se",
  "angstrom.uu.se",  
  "upatras.gr",
  "toyo.jp",
  "mail.sdu.edu.cn",
  "student.uoradea.ro",
  "udc.es",
  "mail.zstu.edu.cn",
  "studenti.univpm.it",
  "stu.xzhmu.edu.cn",
  "vub.be",
  "ufscar.br",
  "njucm-edu.cn",
  "uab.cat",
  "uottawa.ca",
  "ulusofona.pt",
  "lpu.in",
  "connect.hku.hk",
  "gncollege.co.in",
  "stu.scau.edu.cn",
  "uit.no",
  "uni-jena.de",
  "student.vu.nl",
  "uni-lj.si",
  "ul.ie",
  "unam.mx",
  "uni-saarland.de",
  "ubc.ca",
  "stu.cpu.edu.cn",
  "sastra.ac.in",
  "namdu.uz",
  "mail.concordia.ca",
  "uc.cl",
  "gncollege.co.in",
  "etu.univh2c.ma",
  "unibs.it",
  "academicos.udg.mx",
  "academico.udg.mx",
  "utalca.cl",
  "unicampania.it",
  "math.uoc.gr",
  "bzh.uni-heidelberg.de",
  "xalapa.tecnm.mx",
  "itmo.ru",
  "uni-bonn.de",
  "zju.edu.cn",
  "vu.nl",
  "academico.ufpb.br",
  "sxcran.org",
  "lagh-univ.dz",
  "tf.uni-kiel.de",
  "jku.at",
  "uni-bremen.de",
  "simtech.uni-stuttgart.de",
  "karazin.ua",
  "rau.am",
  "aluno.uece.br",
  "cnc.uc.pt",
  "xalapa.tecnm.mx",
  "iop.vast.vn",
  "ucm.es",
  "sfu.ca",
  "ua.pt",
  "erauniversity.in",
  "mbg.au.dk",
  "macfast.org",
  "nbu.bg",
  "phys.chem.ethz.ch",
  "ufba.br",
  "uib.no",
  "univ-setif.dz",
  "aalto.fi",
  "sns.it",
  "mail.pucv.cl",
  "postgrad.manchester.ac.uk",
  "polsl.pl",
  "cpc.tu-darmstadt.de",
  "ethz.ch",
  "maastrichtuniversity.nl",
  "dac.unicamp.br",
  "i2bc.paris-saclay.fr",
  "nmhschool.org",
  "iwr.uni-heidelberg.de",
  "jadavpuruniversity.in",
  "univ-saida.dz",
  "utm.my",
  "alunos.fc.ul.pt",
  "bnds.cn",
  "h-brs.de",
  "studenti.unicam.it",
  "uoguelph.ca",
  "aoni.waseda.jp",
  "uio.no",
  "jindai.jp",
  "ki.si",
  "unamur.be",
  "lic.leidenuniv.nl",
  "nmamit.in",
  "ulb.be",
  "unict.it",
  "id.uff.br",
  "unisalento.it",
  "uv.es",
  "alumnos.udg.mx",
  "staff.univpm.it",
  "spbu.ru",
  "ciencias.ulisboa.pt",
  "edu.hse.ru",
  "uni-wuerzburg.de",
  "biophys.msu.ru",
  "pg.cusat.ac.in",
  "chimieparistech.psl.eu",
  "uniba.sk",
  "uni-koeln.de",
  "ufla.br",
  "edu.spbstu.ru",
  "slu.se",
  "polimi.it",
  "bioss.uni-freiburg.de",
  "dulwich.org.uk",
  "unistra.fr",
  "iephb.ru",
  "mail.polimi.it",
  "imperial.ac.uk",
  "uniba.cm",
  "connect.polyu.hk",
  "studenti.unipg.it",
  "uni.lu",
  "uoa.gr",
  "insa-toulouse.fr",
  "samgtu.ru",
  "physik.uni-augsburg.de",
  "neurology.ru",
  "umu.se",
  "uni-graz.at",
  "std.novsu.ru",
  "chemie.uni-regensburg.de",
  "ucdconnect.ie",
  "siat.ac.cn",
  "unesp.br",
  "studenti.polito.it",
  "gmc.vu.lt",
  "tu-berlin.de",
  "bti.vu.lt",
  "kpfu.ru",
  "iau.ir",
  "misis.ru",
  "ufc.br",
  "prof.ce.gov.br",
  "delhi.gov.in",
  "cmail.carleton.ca",
  "theo.chemie.tu-darmstadt.de",
  "uochb.cas.cz",
  "univates.br",
  "bti.vu.lt",
  "my.msu.ru",
  "univ-constantine3.dz",
  "gmc.vu.lt",
  "univie.at",
  "univ-ndere.cm",
  "cunet.carleton.ca",
  "pharma.unizg.hr",
  "sdu.dk",
  "unizar.es",
  "studserv.uni-leipzig.de",
  "alumno.uaemex.mx",
  "rug.nl",
  "uab.es",
  "gu.se",
  "icmpp.ro",
  "uva.nl",
  "estudiantes.uv.mx",
  "sci.am",
  "ualg.pt",
  "umfst.ro",
  "uneb.br",
  "chem.lu.se",
  "estudiantes.fbio.uh.cu",
  "mcmaster.ca",
  "uni-hamburg.de",
  "uni-mainz.de",
  "ecpt.in",
  "tudelft.nl",
  "baydaauniv.net",
  "ggh.goe.go.kr",
  "tue.nl",
  "vignanpharma.com",
  "kitox.re.kr",
  "dbb.su.se",
  "hse.ru",
  "pfur.ru",
  "alumnos.uach.cl",
  "uni-sofia.bg",
  "institut-agro.fr",
  "univ-biskra.dz",
  "crbt.dz",
  "epri.sci.eg",
  "studio.unibo.it",
  "ugent.be",
  "univ-cotedazur.fr",
  "ccia.uned.es",
  "ufg.br",
  "skoltech.ru",
  "photonics.ru",
  "lsmu.lt",
  "studenti.unipi.it",
  "nitrkl.ac.in",
  "lpu.co.in",
  "incras.ru",
  "uib.es",
  "ufmt.br",
  "fc.ul.pt",
  "itt.uni-stuttgart.de",
  "unito.it",
  "unitn.it",
  "unina.it",
  "uclouvain.be",
  "umlub.pl",
  "bcdapt.com",
  "unicamp.br",
  "smu.ca",
  "ku.dk",
  "studentmail.conroeisd.net",
  "tiiame.uz",
  "uni-marburg.de",
  "sorbonne-universite.fr",
  "ewhain.net",
  "univ-bouira.dz",
  "ufromail.cl",
  "sbmu.ac.ir",
  "etud.univ-evry.fr",
  "enset-skikda.dz",
  "student.cuni.cz",
  "ladybrabourne.com",
  "stud.mh-hannover.de",
  "stuba.sk",
  "up.pt",
  "fias.uni-frankfurt.de",
  "mh-hannover.de",
  "ufrontera.cl",
  "student.put.poznan.pl",
  "alumnos.uaslp.mx",
  "dia.units.it",
  "edu.ruhr-uni-bochum.de",
  "jesuitmail.org",
  "ga.usmk12.org",
  "irim.cnrs.fr",
  "uvigo.es",
  "queensu.ca",
  "vuw.leidenuniv.nl",
  "usc.es",
  "pharmazie.uni-kiel.de",
  "lwsd.org",
  "univ-guelma.dz",
  "usthb.dz",
  "ikasle.ehu.eus",
  "fphm.u-monastir.tn",
  "kadai.jp",
  "excelcolleges.com",
  "uni-leipzig.de",
  "uni-muenster.de",
  "ehu.eus",
  "aut.ac.ir",
  "phd.units.it",
  "chem.kyushu-univ.jp",
  "student.uu.se",
  "alu.ua.es",
  "students.zhaw.ch",
  "hku.hk",
  "zhaw.ch",
  "etu.uca.fr",
  "icen.ufpa.br",
  "ensc.dz",
  "mylife.unisa.ac.za",
  "estudiants.urv.cat",
  "uaemex.mx",
  "ubuea.cm",
  "ufu.br",
  "estudiante.uam.es",
  "semmelweis.hu",
  "chemia.uni.lodz.pl",
  "univ-bangui.org",
  "umft.ro",
  "uca.fr",
  "uef.fi",
  "wflms.com",
  "univ-evry.fr",
  "fss.usf.tn",
  "chemie.uni-frankfurt.de",
  "std.uestc.cn",
  "nh.cas.cz",
  "usj.es",
  "lakeheadu.ca",
  "ipg.pt",
  "uod.ac",
  "urv.cat",
  "upct.es",
  "juitsolan.in",
  "uni-frankfurt.de",
  "cbsd.org",
  "hbucm.edu.cn",
  "univh2c.ma",
  "btbu.cn",
  "unisi.it",
  "kth.se",
  "gxust.edu.cn",
  "jcpsnj.org",
  "bitcollege.in",
  "uni-bielefeld.de",
  "tugraz.at",
  "unison.mx",
  "abo.fi",
  "unipa.it",
  "uni-halle.de",
  "sgsitsindore.in",
  "edu.cn",
  "bucm.edu.cn",
  "lpssy.edu.cn",
  "ncst.edu.cn",
  "henu.edu.cn",
  "fcen.uba.ar",
  "uu.se",
  "uah.es",
  "unicz.it",
  "htw-dresden.de",
  "ufpa.br",
  "ufpb.br",
  "ssmu.ru",
  "smp.udn.vn",
  "uach.cl",
  "gcu.edu.pk",
  "edu.pk",
  "ouc.edu.cn",
  "njau.edu.cn",
  "unimore.it",
  "leidenuniv.nl",
  "sskhannagirlsdc.ac.in",
  "tsu.ru",
  "tuks.co.za",
  "edu.ulisboa.pt",
  "ulisboa.pt",
  "zjut.edu.cn",
  "uaf.edu.pk",
  "tezu.ernet.in",
  "zacapoaxtla.tecnm.mx",
  "sun.hsu.ac.ir",
  "unical.it",
  "kait.jp",
  "umk.pl",
  "mp.aau.dk",
  "isbst.rnu.tn",
  'dal.ca',
  'waseda.jp',
  'edu.univ-oran1.dz',
  'uc.pt',
  'nmbu.no',
  'uni-oldenburg.de',
  'ynu.jp',
  'uniba.it',
  'csu.edu.cn',
  'swun.edu.cn',
  'epamig.br',
  'ipb.pt',
  'myubt.de',
  'facsciences-uy1.cm',
  'alastudents.org',
  'xxmu.edu.cn',
  'zzu.edu.cn',
  'enspd-udo.cm',
  'uni-stuttgart.de',
  'medunigraz.at',
  'ufal.br',
  "acsir.res.in",
  "nitte.edu.in",
  "ecust.edu.cn",
  "smu.edu",
  "dsc.naist.jp",
  "lu.lv",
  "unibo.it",
  "taltech.ee",
  "wlu.ca",
  "shooliniuniversity.com",
  "upch.pe",
  "msu.ru",
  "uniroma3.it",
  "ucc.ie",
  "uaq.mx",
  "univ-amu.fr",
  "uchile.cl",
  "kristujayanti.com",
  "nust.na",
  "osu.ru",
  "tu-darmstadt.de",
  "xidian.edu.cn",
  "univ-medea.dz",
  "njtech.edu.cn",
  "uni-ulm.de",
  "ddsciencehs.djsch.kr",
  "tubitakfenlisesi.k12.tr",
  "gzucm.edu.cn",
  "auth.gr",
  "szte.hu",
  "ich.vast.vn",
  "concordia.ca",
  "uel.br",
  "lu.se",
  "estacio.br",
  "umh.es",
  "keio.jp",
  "uni-kiel.de",
  "univ-batna.dz",
  "sabanciuniv.edu",
  "ipm.ir",
  "rkmvccrahara.org",
  "unipg.it",
  "hkbu.edu.hk",
  "uwl.ac.uk",
  "uba.ar",
  "bub.ernet.in",
  "santa-laurensia.sch.id",
  "ipe.buet.ac.bd",
  "uni.opole.pl",
  "umontreal.ca",
  "christuniversity.in",
  "univ-eloued.dz",
  "uni-duesseldorf.de",
  "cpu.edu.cn",
  "univ-oeb.dz",
  "hlju.cn",
  "ingeb.unsa.ba",
  "su.se",
  "upaep.mx",
  "my.swjtu.edu.cn",
  "uss.cl",
  "uoi.gr",
  "polyu.hk",
  "nsit.net.in",
  "uwindsor.ca",
  "unipi.it",
  "students.chappaquaschools.org",
  "vega.protres.ru",
  "neau.edu.cn",
  "jagannathuniversity.org",
  "usal.es",
  "univ-alger.dz",
  "student.aau.dk",
  "physik.hu-berlin.de",
  "cyu.fr",
  "ens-kouba.dz",
  "uagro.mx",
  "discente.uefs.br",
  "fst.utm.tn",
  "mail.ecust.edu.cn",
  "rnc.amity.edu",
  "estudiantesunap.cl",
  "jnu.edu.cn",
  "kpi.ua",
  "uom.lk",
  "dbb.su.se",
  "lmu.de",
  "uu.nl",
  "sol.cc.u-szeged.hu",
  "toluca.tecnm.mx",
  "univ-skikda.dz",
  "sues.edu.cn",
  "alumnos.upm.es",
  "ilum.cnpem.br",
  "unifr.ch",
  "unirioja.es",
  "bjmu.edu.cn",
  "bce.au.dk",
  "stu.qlu.edu.cn",
  "uach.mx",
  "r7-2.deped.gov.ph",
  "ibc.uni-dtuttgart.de",
  "stu.qlu.edu.cn",
  "students.nsbm.ac.lk",
  "uni.au.dk",
  "lnu.se",
  "hunau.edu.cn",
  "must.edu.pk",
  "pmfst.hr",
  "fct.unl.pt",
  "nshm.com",
  "ua.es",
  "um6p.ma",
  "pmfst.hr",
  "hainanu.edu.cn",
  "georgiancollege.ca",
  "faf.cuni.cz",
  "colpos.mx",
  "giu-uni.de",
  "edu.burnabyschools.ca",
  "icmp.lviv.ua",
  "oist.jp",
  "unitus.it",
  "uust.ru",
  "studenti.unime.it",
  "unime.it",
  "lf1.cuni.cz",
  "northeastern.edu",
  "iitk.ac.in",
  "kust.edu.cn",
  "associated.ltu.se",
  "hainanu.edu.cn",
  "thphys.uni-heidelberg.de",
  "ur.de",
  "ube.fr",
  "usm.cl",
  "std.uestc.edu.cn",
  "biotech.kiit.ac.in",
  "iitg.ac.in",
  "upm.es",
  "sanjivani.org.in",
  "stu.jiangnan.edu.cn",
  "umontpellier.fr",
  "fss.u-sfax.tn",
  "jcu.cz",
  "fss.u-sfax.tn",
  "talantiuspeh.ru",
  "talantiuspeh.ru",
  "ISBSTUDENT.COMSATS.EDU.PK",
  "isbm.u-monastir.tn",
  "njucm.edu.cn",
  "univ-eiffel.fr",
  "usk.ac.id",
  "renertschool.ca",
  "ac.uni-freiburg.de",
  "samsmu.ru",
  "supsi.ch",
  "univ-tissemsilt.dz",
  "zju.edu.cn",
  "stud.u-szeged.hu",
  "cbzrc.pshs.edu.ph",
  "chadwickschool.org",
  "adtu.in",
  "sewanhakaschools.org",
  "uam.es",
  "clpt.in",
  "alumni.unav.es",
  "fjnu.edu.cn",
  "buct.edu.cn",
  "usf.tn",
  "pucv.cl",
  "usf.tn",
  "lumc.nl",
  "uni-a.de",
  "srmist.edu.in",
  "niper.ac.in",
  "ple.lth.se",
  "iseu.by",
  "tum.de",
  "uqtr.ca",
  "nube.unadmexico.mx",
  "edison.k12.nj.us",
  "sastra.ac.in",
  "lcps.org",
  "iitk.ac.in",
  "alu.uern.br",
  "st.jmi.ac.in",
  "unb.ca",
  "upr.si",
  "student.sechenov.ru",
  "p.lodz.pl",
  "uaslp.mx",
  "slpotosicapital.tecnm.mx",
  "jyu.fi",
  "ksa.hs.kr",
  "lcps.org",
  "uaslp.mx",
  "niperahm.res.in",
  "stumail.sdut.edu.cn",
  "uomphysics.net",
  "nmims.in",
  "niperahm.res.in",
  "sdck.in",
  "alm.buap.mx",
  "alumnado.uvigo.gal",
  "med.u-szeged.hu",
  "univ-reunion.fr",
  "xync.edu.cn",
  "buse.ac.zw",
  "pc.uni-freiburg.de",
  "uniri.hr",
  "umich.mx",
  "aluno.saocamilo-sp.br",
  "stuiocb.ictmumbai.edu.in",
  "univ-rennes.fr",
  "lifs.co.in",
  "isbb.u-jendouba.tn",
  "prof.saocamilo-sp.br",
  "myturf.ul.ac.za",
  "stu.ujn.edu.cn",
  "ceu.es",
  "unifg.it",
  "outr.ac.in",
  "um.es",
  "univ-msila.dz",
  "univ-msila.dz",
  "niuniv.com",
  "uca.es",
  "ust.hk",
  "fsm.u-monastir.tn",
  "univ-orleans.fr",
  "unich.it",
  "mendelu.cz",
  "uni-rostock.de",
  "unoeste.br",
  "stud.uni-regensburg.de",
  "unil.ch",
  "stu.njau.edu.cn",
  "uesc.br",
  "student.cup.edu.cn",
  "mk.uni-pannon.hu",
  "utc.fr",
  "etu-unicaen.fr",
  "student.pumc.edu.cn",
  "curaj.ac.in",
  "univ-blida.dz",
  "espci.psl.eu",
  "umcg.nl",
  "ensi-uma.tn",
  "uaem.mx",
  "ensi-uma.tn",
  "bracu.ac.bd",
  "uadeo.mx",
  "uloyola.es",
  "ipca.pt",
  "uktech.net.in",
  "stud.umfdc.ro",
  "univ-mosta.dz",
  "utu.fi",
  "gw-chimie.math.unibuc.ro",
  "discente.ufma.br",
  "iari.res.in",
  "maua.br",
  "unige.it",
  "snnu.edu.cn",
  "iacs.res.in",
  "mail.sdu.edu.cn",
  "univ-na.ci",
  "edu.uaa.mx",
  "tezu.ac.in",
  "svuonline.org",
  "chapingo.mx",
  "uni.tuebingen.de",
  "smail.cczu.edu.cn",
  "isbstudent.comsats.edu.pk",
  "svuonline.org",
  "tanuvas.org.in",
  "alumnos.ubiobio.cl",
  "pccoer.in",
  "my.bpp.com",
  "spes.uniud.it",
  "etu.u-bordeaux.fr",
  "uvigo.gal",
  "iimtindia.net",
  "lecnam.net",
  "pacp.co.in",
  "aui.ma",
  "staffmail.ed.ac.uk",
  "st.niituniversity.in",
  "webmail.hzau.edu.cn",
  "univ-cotedazur.fr",
  "wur.nl",
  "alumnos.uady.mx",
  "uminho.pt",
  "u.nus.edu",
  "anahuac.mx",
  "swin.edu.au",
  "uni-luebeck.de",
  "radboudumc.nl",
  "unab.cl",
  "stud.kaznmu.kz",
  "ufaz.az",
  "uses",
  "aluno.erechim.ifrs.edu.br",
  "insat.ucar.tn",
  "mta.ro",
  "amu.edu.pl",
  "std.cu.ac.bd",
  "uece.br",
  "vnu.edu.vn",
  "etu.unistra.fr",
  "univ-bba.dz",
  "mgumst.org",
  "univ-bba.dz",
  "aluno.puc-rio.br",
  "uefs.br",
  "pratiksha-edu.in",
  "email.sc.edu",
  "etudiant-issbat.utm.tn",
  "fagr.bu.edu.eg",
  "usi.ch",
  "student.sgh.waw.pl",
  "mewaruniversity.co.in",
  "pte.hu",
  "ufma.br",
  "uni-freiburg.de",
  "stu.cpu.edu.cn",
  "aluno.uespi.br",
  "staff.sechenov.ru",
  "my.utsa.edu",
  "jisiasr.org",
  "ssmeridionale.it",
  "shelterisland.k12.ny.us",
  "ec-lyon.fr",
  "ubiobio.cl",
  "ubu.es",
  "mu.ie"
];

export default whiteList;
